// Tiny path-based router. Two routes today:
//   /             → home
//   /r/:code      → room
// History API for client-side navigation; the server's SPA fallback ensures
// direct URLs work too.

export type Route =
  | { name: 'home' }
  | { name: 'room'; code: string }
  | { name: 'admin' };

const ROOM_PATTERN = /^\/r\/([A-Z0-9]+)\/?$/i;
const ADMIN_PATTERN = /^\/admin\/?$/i;

export function parseRoute(pathname: string): Route {
  if (ADMIN_PATTERN.test(pathname)) return { name: 'admin' };
  const m = ROOM_PATTERN.exec(pathname);
  if (m) return { name: 'room', code: m[1]!.toUpperCase() };
  return { name: 'home' };
}

export function navigate(path: string): void {
  if (window.location.pathname === path) return;
  window.history.pushState({}, '', path);
  window.dispatchEvent(new PopStateEvent('popstate'));
}

export function onRouteChange(handler: (route: Route) => void): () => void {
  const fire = () => handler(parseRoute(window.location.pathname));
  window.addEventListener('popstate', fire);
  return () => window.removeEventListener('popstate', fire);
}
